export const environment = {
  production: true,
  upstreamServerEndPoint: "https://dev-elikita-fhir-server-ayenbmg7dje8g8gt.canadacentral-01.azurewebsites.net",
  backendEndPoint: "https://dev-auth-server2-fxhnamccggbtdrfq.southafricanorth-01.azurewebsites.net/fhir",
  patientBackendEndPoint: "https://elikita-nodejs-server-dev-c5gncjdfbtekhkaa.canadacentral-01.azurewebsites.net/api/fhir",
  authBackendEndPoint: "https://dev-auth-server2-fxhnamccggbtdrfq.southafricanorth-01.azurewebsites.net",
  cloudinaryCloudName: 'dtrg3t7ea',
  cloudinaryUploadPreset: 'elikita_uploads',
  messagingFirebaseRoot: 'elikita-dev',
  features: {
    enableBackendPrint: false
  }
};
